export const ARRAY_DELIMITER = ",";
export const SLIDER_DELIMITER = "-";
const _SPACE_DELIMITER = "_";
export const RANGE_DELIMITER = "-";
const _SORT_DELIMITER = ".";
